import { getPhoneFromToken } from '../helpers/decodeJWT'
import { phoneAuthService } from './phone-auth'

const SESSION_TYPE = 'WC_SESSION'
const base = process.env.REACT_APP_SESSIONS_API_BASE

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken')
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  }
}

const apiClient = async ({ url, method, body }) => {
  const response = await fetch(url, {
    method,
    headers: getAuthHeaders(),
    ...(body && { body }),
  })
  if (response.status === 401) {
    // not authorized
    phoneAuthService.clearAuth()
    window.location.replace('/registration')
  }
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('NotFound')
    }
    throw new Error(`HTTP error! status: ${response.status}`)
  }

  const {
    data: { data },
  } = await response.json()
  return data
}

export const fetchSession = async ({ initialData }) => {
  try {
    const data = await apiClient({
      url: `${base}/public/sessions`,
      method: 'GET',
    })
    const parsedData = JSON.parse(data.completedTutorials)
    return parsedData
  } catch (error) {
    if (error?.message === 'NotFound') {
      // Session not found, first visit
      await createSession(initialData)
      return null
    }
    console.error('Error fetching session:', error)
  }
}

export const createSession = async (completedTutorials) => {
  try {
    const body = JSON.stringify({
      sessionDefinitionType: SESSION_TYPE,
      data: {
        completedTutorials: JSON.stringify(completedTutorials),
      },
    })
    const response = await apiClient({
      url: `${base}/public/sessions`,
      method: 'POST',
      body,
    })
    return response
  } catch (error) {
    console.error('Error creating session:', error)
  }
}

export const updateSession = async (completedTutorials) => {
  try {
    const body = JSON.stringify({
      sessionDefinitionType: SESSION_TYPE,
      data: {
        completedTutorials: JSON.stringify(completedTutorials),
      },
    })

    const response = await apiClient({
      url: `${base}/public/sessions`,
      method: 'PUT',
      body,
    })
    return response
  } catch (error) {
    console.error('Error updating session:', error)
  }
}
